// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"9ef84c20","663":"13105ed6","986":"395d2138"}[chunkId] + ".chunk.js";
};